module.exports = __webpack_public_path__ + "img/team_icon_grey.d542b524.svg";